import React from 'react';
import './LegalPage.css';

function AboutAppPage() {
  const isPopup = typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('popup') === '1';
  return (
    <div className="legal-page">
      <div className="legal-page__container">
        {!isPopup && (
          <a href="/" className="legal-page__close" aria-label="Close and return to avatar experience">
            X
          </a>
        )}
        <h1 className="legal-page__title">About App</h1>
        <p className="legal-page__intro">
          Afterlife Bot is a voice-first experience where you can speak naturally with Mr. Edward Berwind of The Elms.
        </p>

        <section className="legal-page__section">
          <h2>How to Use</h2>
          <ul>
            <li><strong>Start the session:</strong> Tap Start Session and allow microphone access when asked.</li>
            <li><strong>Wake phrase:</strong> Say &quot;Hey Edward Berwind&quot; or &quot;Hello Edward Berwind&quot; to begin.</li>
            <li><strong>Visual cue:</strong> A blue ring shows listening, and a rainbow ring shows speaking.</li>
            <li><strong>Interrupt naturally:</strong> Speak while he is talking to cut in, like a normal conversation.</li>
            <li><strong>Session controls:</strong> Use Mute to silence your mic and End Session when finished.</li>
          </ul>

          <h2>Conversation Notes</h2>
          <p>
            Responses are generated by AI in a historical reenactment style and are intended for educational and entertainment use.
          </p>
        </section>

        <div className="legal-page__actions">
          <a href={isPopup ? '/terms-of-service?popup=1' : '/terms-of-service'} className="legal-page__link legal-page__link--secondary">
            View Terms and Conditions
          </a>
          <a href={isPopup ? '/privacy-policy?popup=1' : '/privacy-policy'} className="legal-page__link legal-page__link--secondary">
            View Privacy Policy
          </a>
          {!isPopup && (
            <a href="/" className="legal-page__link">
              Back to Avatar Experience
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default AboutAppPage;
